import axiosClient from "./axiosClient";

export const UserType = {
  User: 1,
  BusinessOwner: 2,
  Delivery: 3,
  Admin: 4,
  DeliveryCompany: 5,
};

export async function login(email, password) {
  const response = await axiosClient.post("/Users/login", {
    email,
    password,
  });
  return response.data;
}
